<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <ItemsTable />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ItemsTable from "../components/ItemsTable";

export default {
  name: "Home",
  data() {
    return {
    };
  },
  components: {
    ItemsTable,
  },
  methods: {
  },
};
</script>
